<template>
  <div class="ws-modal">
    <form class="ws-modal__form" @submit.prevent="submit">
      <header class="ws-modal__header">
        <h2 class="has-text-weight-bold is-size-1">

          <span>{{ $t(`${isNewItem ? 'Создать' : 'Редактировать'} заявку на ДЭ`) }}</span>
        </h2>
      </header>
      <div class="ws-modal__content" :class="{'is-loading':isPending}">
        <div class="columns is-multiline">
          <div class="column is-10" v-if="!isNewItem">
            <b-field class="ws-field is-required"
                     :label="$t('Название экзамена')"
                     :type="{'is-danger': errors.has('name')}"
                     :message="errors.first('name')">
              <b-input class="ws-field__control"
                       data-id="modal-form_exam-name-input"
                       v-model="newItem.name.translate.ru"
                       v-validate="{ required: true, validateSpecialCharacters: true, max: 255}"
                       :data-vv-as="$t('Название экзамена')"
                       name="name"
              />
            </b-field>
          </div>
          <div class="column is-2" v-if="!isNewItem">
            <div class="field-upd-title">
              <b-checkbox v-model="updateTitle" class="b-checkbox">
                <b>Обновить наименование</b><br>
              </b-checkbox>
            </div>
          </div>
          <div class="column is-4">
            <div class="ws-datepicker">
              <b-field class="ws-field"
                       :label="$t('Подготовительный день')"
                       :type="{'is-danger': errors.has('day_cm1')}"
                       :message="errors.first('day_cm1') || errorDayCmDayOff">
                <ws-datepicker
                    data-id="modal-form_datepicker-day-cm1"
                    v-validate="'required|validateYear'"
                    v-model="day_cm1"
                    :data-vv-as="$t('Подготовительный день')"
                    name="day_cm1"
                    @input="onSelectDaycm1">
                </ws-datepicker>
              </b-field>
            </div>
          </div>
          <div class="column is-8" data-id="modal-form_competence-column">
            <b-field class="ws-field"
                     :label="$t('Профессия/специальность (ДЭ)')"
                     :type="{'is-danger': errors.has('competence')}"
                     :message="errors.first('competence')">
              <ws-refbook-field
                  entity="competence"
                  field="name.display"
                  name="competence"
                  :guid.sync="competence.guid"
                  :item.sync="competence.item"
                  v-model="competence.value"
                  :query="{wo_skill: true}"
                  @change="selectCompetence"
                  :disabled="isCompetenceDisable"
                  v-validate="{ required: true, selected: competence.guid}"
                  :data-vv-as="$t('Профессия/специальность (ДЭ)')"
                  :isFocus="true">
                <template slot="empty" v-text="$t('Ничего не найдено')"></template>
              </ws-refbook-field>
            </b-field>
          </div>
          <div class="column is-5">
            <b-field class="ws-field"
                     :label="$t('Квалификация')"
                     :type="{'is-danger': errors.has('complexity_level')}"
                     :message="errors.first('complexity_level')">
              <WsSelectComplexityCode
                  :value="newItem.accred_comps.complexity_level"
                  :on-change="selectComplexy"
                  :disabled="!competence.item.guid"
                  :competence="competence"
                  :placeholder="$t('')"
                  open-on-focus
                  v-validate="{ required: true, validateSpecialCharacters: true, max: 255 }"
                  :name="'complexity_level'"
                  :class="'ws-field__control'"
              />
            </b-field>
          </div>
          <!-- <div class="column is-2">
            <b-field class="ws-field" :label="$t('Наличие КОД')">
              <b-input class="ws-field__control"
                       data-id="modal-form_code-input"
                       readonly
                       :value="isHasCod() ? $t('Есть') : $t('Нет')"
                       :data-vv-as="$t('Наличие КОД')"
                       :placeholder="$t('')"/>
            </b-field>
          </div> -->

          <!--          <div class="column is-4" v-if="!isNewItem">-->
          <!--            <b-field class="ws-field"-->
          <!--                     :label="$t('Дата начала')"-->
          <!--                     :type="{'is-danger': errors.has('started_at')}"-->
          <!--                     :message="errors.first('started_at')">-->
          <!--              <ws-datepicker-->
          <!--                v-validate="{ required: true }"-->
          <!--                v-model="started_at"-->
          <!--                :data-vv-as="$t('Дата начала')"-->
          <!--                :min-date="day_cm1"-->
          <!--                :max-date="ended_at"-->
          <!--                name="started_at"-->
          <!--                class="ws-field__control">-->
          <!--              </ws-datepicker>-->
          <!--            </b-field>-->
          <!--          </div>-->
          <!--          <div class="column is-4" v-if="!isNewItem">-->
          <!--            <b-field class="ws-field"-->
          <!--                     :label="$t('Дата окончания')"-->
          <!--                     :type="{'is-danger': errors.has('ended_at')}"-->
          <!--                     :message="errors.first('ended_at')">-->
          <!--              <ws-datepicker-->
          <!--                v-validate="{ required: true }"-->
          <!--                v-model="ended_at"-->
          <!--                :min-date="started_at"-->
          <!--                :data-vv-as="$t('Дата окончания')"-->
          <!--                name="ended_at"-->
          <!--                class="ws-field__control">-->
          <!--              </ws-datepicker>-->
          <!--            </b-field>-->
          <!--          </div>-->
          <div class="column is-7" data-id="modal-form_de-center-column">
            <b-field class="ws-field"
                     :label="$t('Центр проведения демонстрационного экзамена')"
                     :type="{'is-danger': errors.has('deCenter')}"
                     :class="{'cpde-invisible' : !isVisible}"
                     :message="errors.first('deCenter')">
              <ws-refbook-field
                  entity="de-centers"
                  field="name.display"
                  name="deCenter"
                  :guid.sync="deCenter.guid"
                  :item.sync="deCenter.item"
                  v-model="deCenter.value"
                  @change="selectDeCenter"
                  v-validate="{ required: true, selected: deCenter.guid }"
                  :data-vv-as="$t('Центр проведения демонстрационного экзамена')"
                  :isFocus="true">
                <template slot="item" slot-scope="props">
                  <p>{{ props.option.name.display }}</p>
                  <small class="has-text-grey">{{ getDeCenterOptionSubTitle(props.option) }}</small>
                </template>
                <template slot="empty" v-text="$t('Ничего не найдено')"></template>
              </ws-refbook-field>
            </b-field>
          </div>
        </div>

        <!-- Shifts and groups -->
        <div class="columns is-multiline" v-if="isNewItem && isCreateShift">
          <div class="column is-4">
            <b-field class="ws-field"
                     :label="$t('Выдача задания')"
                     :type="{'is-danger': errors.has('job_issued_at')}"
                     :message="errors.first('job_issued_at')">
              <ws-datepicker
                  v-validate="{ required: true }"
                  data-id="modal-form_issued-at-datepicker"
                  :focused-date="day_cm1"
                  @input="onJobIssuedAtChange"
                  :min-date="day_cm1"
                  v-model="job_issued_at"
                  :disabled="!newItem.accred_comps.complexity_level || !day_cm1"
                  name="job_issued_at"
                  class="ws-field__control">
              </ws-datepicker>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field class="ws-field"
                     :label="$t('Дата начала')"
                     :type="{'is-danger': errors.has('started_at')}"
                     :message="errors.first('started_at')">
              <ws-datepicker
                  data-id="modal-form_started-at-datepicker"
                  v-model="shift_started_at"
                  :disabled="!newItem.accred_comps.complexity_level || !day_cm1"
                  v-validate="{ required: true }"
                  :focused-date="day_cm1"
                  :min-date="day_cm1"
                  name="started_at"
                  class="ws-field__control">
              </ws-datepicker>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field class="ws-field"
                     :label="$t('Дата окончания')"
                     :type="{'is-danger': errors.has('ended_at')}"
                     :message="errors.first('ended_at')">
              <ws-datepicker
                  data-id="modal-form_ended-at-datepicker"
                  v-model="shift_ended_at"
                  :disabled="!newItem.accred_comps.complexity_level || !day_cm1"
                  v-validate="{ required: true }"
                  :focused-date="day_cm1"
                  :min-date="day_cm1"
                  name="ended_at"
                  class="ws-field__control">
              </ws-datepicker>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field class="ws-field is-required"
                     :label="$t('№ Смены')"
                     :type="{'is-danger': errors.has('shift_number')}"
                     :message="errors.first('shift_number')">
              <b-select class="ws-field__control"
                        data-id="modal-form_shift-number-select"
                        name="shift_number"
                        v-validate="{ required: true }"
                        v-model="shift.number"
                        expanded>
                <option v-for="option in shiftNumbers"
                        :value="option"
                        :key="option">
                  {{ option }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-7">
            <b-field class="ws-field"
                     :label="$t('Выберите учебную группу')"
                     :type="{'is-danger': errors.has('group')}"
                     :message="errors.first('group')">
              <ws-refbook-field
                  entity="refbook/study_groups"
                  data-id="modal-form_education-group-field"
                  name="group"
                  field="name"
                  v-model="shift.education_group.name"
                  :guid.sync="shift.education_group.guid"
                  :isFocus="true"
                  key="group-input"
                  v-validate="{ required: true, selected: shift.education_group.guid }">
                <template slot-scope="props" slot="item">
                  <div :title="`
                    ${props.option.name} ${props.option.education_year}/${props.option.education_year+1}\n
                    ${props.option.profession || ''}\n
                    ${props.option.university ? props.option.university.title.display : ''}
                  `">
                    <strong v-text="props.option.name"></strong>
                    <span class="ml-1 has-text-danger">{{
                        props.option.education_year
                      }}/{{ props.option.education_year + 1 }}</span><br>
                    <span v-text="props.option.profession"></span><br>
                    <span v-text="props.option.university ? props.option.university.title.display : ''"></span>
                  </div>
                </template>
                <template slot="empty" v-text="$t('Ничего не найдено')"></template>
              </ws-refbook-field>
            </b-field>
          </div>
          <div class="column is-3 floated-button-container">
            <b-field class="ws-field is-required"
                     :label="$t('Сдающих (план)')"
                     :type="{'is-danger': errors.has('student')}"
                     key="student-input"
                     :message="errors.first('student')">
              <b-input class="ws-field__control"
                       v-model.number="shift.student"
                       v-validate="{ required: true }"
                       name="student"
              />
            </b-field>
          </div>
        </div>

        <ws-request-exam-type-form
          v-validate="{
            typesRequired: {
              schema: this.isFgos ? this.typesSchemaFgos : this.typesSchema
            }
          }"
          :items="isFgos ? typesSchemaFgos : typesSchema"
          :value="typesModel"
          name="types"
          @input="onTypes"
        ></ws-request-exam-type-form>
        <div class="columns">
          <div class="column is-12" v-if="errors.has('types')">
            <p class="has-text-danger is-size-5">{{ $t('Необходимо выбрать тип заявки') }}</p>
          </div>
        </div>
        <ws-request-exam-code-type-form
            :value="this.selectedCodeType"
            :items="this.codeTypesSchema"
            @input="onCodeTypes"
            name="codeTypes">
        </ws-request-exam-code-type-form>

        <div class="columns" v-show="isShowIndependentEstimate">
          <div class="column is-2 is-size-4">
            <b-checkbox
                name="independent_estimate"
                class="b-checkbox__centered"
                :disabled="!isHasQualifications"
                v-model="independent_estimate">
              <b>{{ $t('flags.independent_estimate') }}</b>
            </b-checkbox>
          </div>
          <div class="column is-8" data-id="modal-form_qualification-column">
            <b-field class="ws-field"
                     :label="$t('Квалификация')"
                     :type="{'is-danger': errors.has('qualification')}"
                     :message="errors.first('qualification')">
              <ws-refbook-field
                  entity="skill-matrix/qualification"
                  :query="{flags: subtype, competency_guids: competence.guid, complexity_levels: newItem.accred_comps.complexity_level }"
                  field="name.translate.ru"
                  name="qualification"
                  :disabled="!isSelectQualification"
                  :guid.sync="qualification.guid"
                  :item.sync="qualification.item"
                  v-model="qualification.value"
                  @change="selectQualification"
                  v-validate="{ required: !!independent_estimate, selected: qualification.guid }"
                  :data-vv-as="$t('Квалификация')"
                  :isFocus="true">
                <template slot="empty" v-text="$t('Ничего не найдено')"></template>
              </ws-refbook-field>
            </b-field>
          </div>
          <div class="column is-2 is-size-4">
            <b-field class="ws-field" :label="$t('Уровень')">
              <b-input class="ws-field__control"
                       readonly
                       data-id="modal-form_qualification-item-level-input"
                       :disabled="!isSelectQualification"
                       :value="qualification && qualification.item && qualification.item.level"
                       :placeholder="$t('')"/>
            </b-field>
          </div>
        </div>

        <div class="columns">
          <div class="column is-size-4">
            <div>
              <b-checkbox
                  name="remote"
                  class="b-checkbox__centered"
                  v-model="remote_experts">
                <b>{{ $t('Удаленное присутствие одного или нескольких экспертов (ГЭ или эксперт)') }}</b>
              </b-checkbox>
            </div>
            <div>
              <b-checkbox
                  name="remote"
                  class="b-checkbox__centered"
                  v-model="remote_members">
                <b>{{ $t('Участники присутствуют на ДЭ дистанционно (удаленно)') }}</b>
              </b-checkbox>
            </div>
          </div>
        </div>
      </div>
      <footer class="ws-modal__footer">
        <div class="columns">
          <div class="column is-8"></div>
          <div class="column is-4 is-vcentered">
            <div class="has-text-right-desktop">
              <button data-id="modal-form_action-button" class="ws-button button is-large is-primary is-fullwidth"
                      :class="{'is-loading':isPending}">
                <span class="is-size-4 has-text-weight-bold" v-if="!isNewItem" v-text="$t('Редактировать')"></span>
                <span class="is-size-4 has-text-weight-bold" v-else v-text="$t('Создать')"></span>
              </button>
            </div>
          </div>
        </div>
      </footer>
    </form>
    <aside class="ws-modal__sidebar">
      <button class="ws-button button is-text"
              @click="close">
        <ws-icon
            class="ws-button__icon"
            name="close-thin"
            color="#000000"
            :fill="true"
            :title="$t('Закрыть')"
            width="17"
            height="18"
        />
      </button>
    </aside>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import computedDateProp from '@/utils/computedDateProp'
import moment from 'moment'
import WsDatepicker from '@/components/common/WsDatepicker'
import WsSelectComplexityCode from '@/components/common/WsSelectComplexityCode.vue'
import { constants } from '@/services/constants.service'
import { parseTitle } from '@/utils/parse-exam-title'
import WsRequestExamCodeTypeForm from '../WsRequestExamCodeTypeForm.vue'
import { toUTCDay } from '@/utils/helpers'
// const getNextDay = function (date) {
//   const day = moment(date)
//   if (day.isValid()) {
//     const daysToAdd = day.weekday() === 5 ? 2 : 1
//     return day.weekday(day.weekday() + daysToAdd)
//   }
//   return null
// }

// TODO: PROF-14 skill-matrix
export default {
  name: 'WsRequestExamsForm',
  components: { WsRequestExamCodeTypeForm, WsDatepicker, WsSelectComplexityCode },
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          name: {
            translate: {
              ru: ''
            }
          },
          de_center: {
            guid: null,
            title: {
              translate: {
                ru: ''
              }
            }
          },
          accred_comps: {
            number: null,
            competency: {
              code: null,
              guid: null,
              name: {
                translate: {
                  ru: ''
                }
              }
            },
            status: null,
            complexity_level: null
          },
          qualification: {
            guid: null,
            name: {
              translate: {
                ru: ''
              }
            }
          },
          day_cm1: null,
          started_at: null,
          ended_at: null,
          flags: [],
          complexity_level: null,
          status: 'new'
        }
      }
    },
    fgos: Boolean
  },
  data () {
    return {
      isHasQualifications: false,
      isVisible: false,
      deCenter: {
        value: '',
        guid: null,
        item: null
      },
      competence: {
        value: '',
        guid: null,
        item: null
      },
      qualification: {
        value: '',
        guid: null,
        item: null
      },
      updateTitle: true,
      newItem: this.item,
      independent_estimate: null,
      isFgos: null,
      remote_experts: null,
      remote_members: null,
      constants,
      shift: {
        education_group: {
          value: '',
          guid: null,
          item: null
        },
        day_cm1: null,
        job_issued_at: null,
        started_at: null,
        ended_at: null,
        student: null,
        number: 1
      },
      shiftNumbers: (function () {
        const arr = []
        let i = 1
        do {
          arr.push(i++)
        } while (i < 9)
        return arr
      })(),
      typesModel: [null],
      codeTypesModel: null,

      typesSchemaFgos: [
        // [
        //   { title: this.$t('flags.secondary_degree'), value: 'secondary_degree' }
        // ],
        [
          {
            title: this.$t('flags.intermediate.title'),
            subtitle: this.$t('flags.intermediate.subtitle'),
            value: 'intermediate',
            parents: [
              // 'secondary_degree'
            ]
          },
          {
            title: this.$t('flags.total.title'),
            subtitle: this.$t('flags.total.subtitle'),
            value: 'total',
            parents: [
              // 'secondary_degree'
            ]
          },
          {
            title: this.$t('flags.state_final_attestation.title'),
            subtitle: this.$t('flags.state_final_attestation.subtitle'),
            value: 'state_final_attestation',
            parents: [
              // 'secondary_degree'
            ]
          }
        ]
      ],

      typesSchema: [
        [
          { title: this.$t('flags.secondary_degree'), value: 'secondary_degree' },
          { title: this.$t('flags.university_degree'), value: 'university_degree' },
          { title: this.$t('flags.additional_education'), value: 'additional_education' },
          { title: this.$t('flags.commercial_exam'), value: 'commercial_exam' },
          { title: this.$t('flags.professional_education'), value: 'professional_education' },
          { title: this.$t('flags.other_exam'), value: 'other_exam' }
        ],
        [
          {
            title: this.$t('flags.intermediate.title'),
            subtitle: this.$t('flags.intermediate.subtitle'),
            value: 'intermediate',
            parents: [
              'secondary_degree', 'university_degree'
            ]
          },
          {
            title: this.$t('flags.total.title'),
            subtitle: this.$t('flags.total.subtitle'),
            value: 'total',
            parents: [
              'secondary_degree', 'university_degree'
            ]
          },
          {
            title: this.$t('flags.state_final_attestation.title'),
            subtitle: this.$t('flags.state_final_attestation.subtitle'),
            value: 'state_final_attestation',
            parents: [
              'secondary_degree'
            ]
          },
          {
            title: this.$t('flags.juniors'),
            value: 'juniors',
            parents: [
              'professional_education'
            ]
          },
          {
            title: this.$t('flags.wise'),
            value: 'wise',
            parents: [
              'professional_education'
            ]
          },
          {
            title: this.$t('flags.regions'),
            value: 'regions',
            parents: [
              'professional_education'
            ]
          },
          {
            title: this.$t('flags.other'),
            value: 'other',
            parents: [
              'professional_education'
            ]
          },
          {
            title: this.$t('flags.additional_professional_education'),
            value: 'additional_professional_education',
            parents: [
              'additional_education'
            ]
          },
          {
            title: this.$t('flags.additional_education_junior_adult'),
            value: 'additional_education_junior_adult',
            parents: [
              'additional_education'
            ]
          }
        ],
        [
          {
            title: this.$t('flags.qualification_masters.title'),
            subtitle: this.$t('flags.qualification_masters.subtitle'),
            value: 'qualification_masters',
            parents: [
              'additional_professional_education'
            ]
          },
          {
            title: this.$t('flags.qualification_wise.title'),
            subtitle: this.$t('flags.qualification_wise.subtitle'),
            value: 'qualification_wise',
            parents: [
              'additional_professional_education'
            ]
          },
          {
            title: this.$t('flags.qualification_regions.title'),
            subtitle: this.$t('flags.qualification_regions.subtitle'),
            value: 'qualification_regions',
            parents: [
              'additional_professional_education'
            ]
          },
          {
            title: this.$t('flags.qualification_others.title'),
            subtitle: this.$t('flags.qualification_others.subtitle'),
            value: 'qualification_others',
            parents: [
              'additional_professional_education'
            ]
          },
          {
            title: this.$t('flags.retraining_masters.title'),
            subtitle: this.$t('flags.retraining_masters.subtitle'),
            value: 'retraining_masters',
            parents: [
              'additional_professional_education'
            ]
          },
          {
            title: this.$t('flags.retraining_wise.title'),
            subtitle: this.$t('flags.retraining_wise.subtitle'),
            value: 'retraining_wise',
            parents: [
              'additional_professional_education'
            ]
          },
          {
            title: this.$t('flags.retraining_regions.title'),
            subtitle: this.$t('flags.retraining_regions.subtitle'),
            value: 'retraining_regions',
            parents: [
              'additional_professional_education'
            ]
          },
          {
            title: this.$t('flags.retraining_others.title'),
            subtitle: this.$t('flags.retraining_others.subtitle'),
            value: 'retraining_others',
            parents: [
              'additional_professional_education'
            ]
          },
          {
            title: this.$t('flags.additional_education_junior_adult_common.title'),
            value: 'additional_education_junior_adult_common',
            parents: [
              'additional_education_junior_adult'
            ]
          },
          {
            title: this.$t('flags.additional_education_junior_adult_professional.title'),
            value: 'additional_education_junior_adult_professional',
            parents: [
              'additional_education_junior_adult'
            ]
          }
        ]
      ],
      codeTypesSchema: [
        { title: 'Базовый уровень', value: 'de_level_basic' },
        { title: 'Профильный уровень', value: 'de_level_prof_skill' }
        // { title: 'Профильный уровень "Профессионалитет"', value: 'de_level_proffisionalitet' }
      ],
      selectedCodeType: null
    }
  },
  watch: {
    item: {
      immediate: true,
      // deep: true,
      handler (item) {
        this.deCenter.guid = this.newItem.de_center.guid
        this.competence.guid = this.newItem.accred_comps.competency.guid
        this.competence.item = this.newItem.accred_comps.competency
        this.isVisible = typeof this.newItem.de_center.visible === 'undefined' ? true : this.newItem.de_center.visible
        if (this.newItem.de_center && this.newItem.de_center.name && this.newItem.de_center.name.display) {
          this.deCenter.value = this.newItem.de_center.name.display
        }
        if (this.newItem.accred_comps.competency && this.newItem.accred_comps.competency.name && this.newItem.accred_comps.competency.name.display) {
          this.competence.value = this.newItem.accred_comps.competency.name.display
        }
        if (this.newItem.qualification) {
          this.qualification.guid = this.newItem.qualification.guid
          this.qualification.item = this.newItem.qualification
        }
        if (this.newItem.qualification && this.newItem.qualification.name && this.newItem.qualification.name.display) {
          this.qualification.value = this.newItem.qualification.name.display
        }
        const arr = []
        item.flags.forEach(f => {
          switch (f) {
            case 'university_degree':
            case 'secondary_degree':
            case 'commercial_exam':
            case 'additional_education':
            case 'professional_education':
            case 'other_exam':
            case 'total':
            case 'intermediate':
            case 'voluntary_qualify_exam':
            case 'state_final_attestation':
            case 'juniors':
            case 'wise':
            case 'regions':
            case 'other':
            case 'additional_professional_education':
            case 'additional_education_junior_adult':
            case 'qualification_masters':
            case 'qualification_wise':
            case 'qualification_regions':
            case 'qualification_others':
            case 'retraining_masters':
            case 'retraining_wise':
            case 'retraining_regions':
            case 'retraining_others':
            case 'additional_education_junior_adult_common':
            case 'additional_education_junior_adult_professional':
              let schema
              if (this.isFgos) {
                schema = this.typesSchemaFgos
              } else {
                schema = this.typesSchema
              }
              schema.forEach((level, index) => {
                level.forEach(item => {
                  if (item.value === f) {
                    arr[index] = f
                  }
                })
              })
              this.typesModel = arr
              break
            case 'independent_estimate':
              this.independent_estimate = true
              break
            case 'state_standard':
              this.isFgos = true
              break
            case 'not_state_standard':
              this.isFgos = false
              break
            case 'university':
              this.is_university = true
              break
            case 'remote_experts':
              this.remote_experts = true
              break
            case 'remote_members':
              this.remote_members = true
              break
            case 'regional_exam':
              this.is_regional = true
              break
            case 'de_level_basic':
              this.selectedCodeType = 'de_level_basic'
              break
            case 'de_level_prof_skill':
              this.selectedCodeType = 'de_level_prof_skill'
              break
            case 'de_level_proffisionalitet':
              this.selectedCodeType = 'de_level_proffisionalitet'
              break
          }
          // TODO сюда добавить проверку флага по типу кода
        })
        this.newItem = item
      }
    },
    codeTypesModel: {
      deep: true,
      async handler () {
        this.updateFlags()
      }
    },
    typesModel: {
      deep: true,
      async handler () {
        this.updateFlags()
        this.independent_estimate = null
        this.clearQualification()
        await this.checkQualification()
      }
    },
    fgos: {
      immediate: true,
      handler (item) {
        this.isFgos = !!item
      }
    },
    types: {
      handler (types) {
        this.updateFlags()
      }
    },
    day_cm1 () {
      this.updateExamTitle()
    }
  },
  computed: {
    ...mapGetters('calendarGeneral', ['datesCalendar']),
    ...mapState('exams', {
      isUpdatePending: 'isUpdatePending',
      isCreatePending: 'isCreatePending'
    }),
    ...mapState('authentication', ['currentRole']),
    errorDayCmDayOff () {
      // или год из значения или текущий год
      const currentYear = this.day_cm1 ? new Date(this.day_cm1).getFullYear() : new Date().getFullYear()
      // получение нужного массива по году из стора
      const events = this.datesCalendar && this.datesCalendar[currentYear]
        ? this.datesCalendar[currentYear].list : []
      // входил ли выбранная дата в массив, если входит, значит это или выходной или прадничный день
      return events.find(function (elem) {
        return this.day_cm1 && elem.date.getTime() === new Date(toUTCDay(this.day_cm1).toISOString()).getTime()
      }.bind(this)) ? 'Обратите внимание, в датах ДЭ присутствуют выходные или праздничные дни' : ''
    },
    isPending () {
      return this.isCreatePending || this.isUpdatePending
    },
    isNewItem () {
      return !(this.newItem && this.newItem.guid)
    },
    isCompetenceDisable () {
      return !!(this.newItem && ((this.newItem.experts && this.newItem.experts.length) || this.newItem.main_expert))
    },
    day_cm1: computedDateProp('newItem', 'day_cm1'),
    started_at: computedDateProp('newItem', 'started_at'),
    ended_at: computedDateProp('newItem', 'ended_at'),
    job_issued_at: computedDateProp('shift', 'job_issued_at'),
    shift_started_at: computedDateProp('shift', 'started_at'),
    shift_ended_at: computedDateProp('shift', 'ended_at'),
    types () {
      return this.independent_estimate + this.remote_members + this.remote_experts
    },
    isCreateShift () {
      return this.currentRole === 'front_curator' || this.currentRole === 'front_curator_institution' || this.currentRole === 'front_university'
    },
    isSelectQualification () {
      return [
        constants.exam_flags.TOTAL,
        constants.exam_flags.INTERMEDIATE,
        constants.exam_flags.GIA
      ].indexOf(this.subtype) > -1 &&
          this.independent_estimate &&
          this.competence.guid &&
          this.newItem.accred_comps.complexity_level
    },
    typeErrors () {
      let isHasErrors = false
      for (const level of this.typesModel) {
        if (this.errors.has(level)) {
          isHasErrors = true
          break
        }
      }
      return isHasErrors
    },
    isShowIndependentEstimate () {
      return this.typesModel && this.typesModel[0] && (this.typesModel[0] === 'university_degree')
    },
    subtype () {
      return this.typesModel && this.typesModel[1]
    }
  },
  mounted () {
    this.$validator.pause()
    if (this.newItem.flags.indexOf('state_standard') === -1 && this.newItem.flags.indexOf('not_state_standard') === -1) {
      this.newItem.flags.push(this.isFgos ? 'state_standard' : 'not_state_standard')
    }
    if (this.newItem.flags.indexOf('state_standard') > -1) {
      this.isFgos = true
    }
    if (this.fgos) {
      for (const [index, level] of this.typesSchemaFgos.entries()) {
        if (level.value === 'secondary_degree') {
          this.typesModel[index] = level.value
          this.newItem.flags.push(level.value)
          break
        }
      }
    }
    switch (this.currentRole) {
      case 'front_university':
        this.is_university = true
        break
      case 'front_dep':
      case 'front_admin':
      case 'front_me':
      case 'front_mc':
      case 'front_rcc':
      case 'front_curator':
      case 'front_curator_institution':
      case 'front_assessor':
        this.is_regional = true
        break
      default:
        this.is_regional = true
    }
    this.checkQualification()
  },
  methods: {
    ...mapActions('exams', ['create', 'update']),
    ...mapActions('exams/shifts', {
      createShift: 'create'
    }),
    ...mapActions('skill-matrix/qualification', {
      findQualification: 'find'
    }),
    onUpdateTitle () {
      this.updateTitle = !this.updateTitle
    },
    updateExamTitle () {
      if (this.updateTitle) {
        this.newItem.name.translate.ru = parseTitle(this.newItem.name.translate.ru, this.day_cm1, this.newItem.accred_comps.complexity_level)
      }
    },
    updateFlags () {
      this.newItem.flags = []
      this.isFgos && this.newItem.flags.push('state_standard')
      !this.isFgos && this.newItem.flags.push('not_state_standard')
      this.independent_estimate && this.newItem.flags.push('independent_estimate')
      this.remote_experts && this.newItem.flags.push('remote_experts')
      this.remote_members && this.newItem.flags.push('remote_members')
      if (this.is_university) {
        this.newItem.flags.push('university')
      }
      if (this.is_regional) {
        this.newItem.flags.push('regional_exam')
      }

      this.typesModel.forEach((value, index) => {
        if (value) {
          this.newItem.flags.push(value)
        }
      })
      if (this.selectedCodeType !== null) {
        this.newItem.flags.push(this.selectedCodeType)
      }
    },
    onTypes (value) {
      this.typesModel = value
    },
    onCodeTypes (value) {
      this.selectedCodeType = value
      this.updateFlags()
    },
    async checkQualification () {
      let result
      if (this.subtype && this.competence && this.competence.guid && this.newItem.accred_comps && this.newItem.accred_comps.complexity_level) {
        const query = {
          flags: this.subtype,
          competency_guids: this.competence.guid,
          complexity_levels: this.newItem.accred_comps.complexity_level
        }
        result = await this.findQualification({ query })
      }
      this.isHasQualifications = result && result.length > 0
      if (!this.independent_estimate) {
        this.independent_estimate = false
      }
    },
    clearQualification () {
      this.qualification.guid = null
      this.qualification.item = {}
      this.qualification.value = ''
    },
    async onSelectCompexityLevel () {
      this.clearQualification()
      await this.checkQualification()
    },
    onJobIssuedAtChange (value) {
      const issuedAt = moment(value)
      if (issuedAt.isValid()) {
        if (this.newItem.accred_comps && this.newItem.accred_comps.complexity_level && this.newItem.accred_comps.complexity_level[0] !== undefined) {
          switch (this.newItem.accred_comps.complexity_level[0]) {
            case '1':
              this.shift_started_at = issuedAt.add(1, 'days')
              this.shift_ended_at = issuedAt
              break
            case '2':
              this.shift_started_at = issuedAt.add(1, 'days')
              this.shift_ended_at = issuedAt.add(1, 'days')
              break
            case '3':
              this.shift_started_at = issuedAt.add(1, 'days')
              this.shift_ended_at = issuedAt.add(2, 'days')
              break
            default:
              this.shift_started_at = null
              this.shift_ended_at = null
          }
        }
      }
    },
    onSelectDaycm1 (date) {
      // this.started_at = getNextDay(date)
      // this.ended_at = getNextDay(date)
    },
    async selectCompetence (competence) {
      if (competence) {
        this.newItem.accred_comps.competency = competence
        if (!competence.guid) {
          this.newItem.accred_comps.complexity_level = null
        }
      }
      this.clearQualification()
      await this.checkQualification()
    },
    selectComplexy (value) {
      this.newItem = {
        ...this.newItem,
        accred_comps: {
          ...this.newItem.accred_comps,
          complexity_level: value
        }
      }
    },
    selectDeCenter (deCenter) {
      if (deCenter) {
        this.newItem.de_center.guid = deCenter.guid
        this.isVisible = typeof deCenter.visible === 'undefined' ? true : deCenter.visible
      }
    },
    selectQualification (qualification) {
      if (qualification) {
        if (!this.newItem.qualification) {
          this.newItem.qualification = {
            value: '',
            guid: null,
            item: null
          }
        }
        this.newItem.qualification.guid = qualification.guid
      }
    },
    isHasCod () {
      if (this.competence.item && this.competence.item.complexity_level && this.competence.item.complexity_level.length) {
        return this.competence.item.complexity_level.indexOf(this.newItem && this.newItem.accred_comps && this.newItem.accred_comps.complexity_level) > -1
      } else {
        return false
      }
    },
    getDeCenterOptionSubTitle (option) {
      return [
        option.address.region ? option.address.region.title.display : '',
        option.address.locality ? option.address.locality.title.display : '',
        option.address.address.display
      ].filter(Boolean).join(', ')
    },
    submit () {
      this.$validator.resume()
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          delete this.newItem.accred_comps.guid
          const normalizedDayCm1 = moment(this.newItem.day_cm1).format('D.MM.YYYY')
          const complexityLevel = this.newItem.accred_comps.complexity_level ? `${this.newItem.accred_comps.complexity_level} ` : ''
          if (this.isNewItem) {
            this.newItem.name.translate.ru = `${normalizedDayCm1} ${complexityLevel}${this.newItem.accred_comps.competency.name.translate.ru}`
            // Create new exam
            const newExam = await this.create(this.newItem)
            if (this.isCreateShift) {
              // Create new shift
              const newShift = await this.createShift([{
                'number': this.shift.number,
                'job_issued_at': this.shift.job_issued_at,
                'started_at': this.shift.started_at,
                'ended_at': this.shift.ended_at
              }, `/${newExam.guid}/shifts`])

              // Create new exam group
              await this.createShift([{
                'shift': {
                  'guid': newShift.guid
                },
                'education_group': {
                  'guid': this.shift.education_group.guid
                },
                'student': this.shift.student
              }, `/${newExam.guid}/shifts/${newShift.guid}/groups`])
            }

            this.$buefy.toast.open({
              message: this.$t(`Заявка ${this.newItem.name.translate.ru} успешно создана`),
              type: 'is-success'
            })
          } else {
            await this.update([this.newItem.guid, this.newItem])
            this.$buefy.toast.open({
              message: this.$t(`Заявка ${this.newItem.name.translate.ru} успешно обновлена`),
              type: 'is-success'
            })
          }
          this.$emit('editExam', this.newItem)
          this.$parent.close()
        }
      })
    },
    close () {
      this.$parent.close()
    }
  }
}
</script>
<style lang="scss" scoped>
.field-upd-title {
  display: flex;
  align-items: center;
  height: 100%;
}

.cpde-invisible {
  /deep/ .ws-field__control.autocomplete .input {
    padding-left: 30px;
  }

  /deep/ .control {
    position: relative;

    &::before {
      content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='red' d='M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z'/%3E%3C/svg%3E");
      width: 12px;
      height: 12px;
      position: absolute;
      left: 14px;
      z-index: 1;
      display: inline-block;
      top: 24px;
    }
  }
}

.ml-1 {
  margin-left: 1rem;
}
</style>
